import { FormStateType } from "../../../../types";
import { ADDITIONAL_INFORMATION_CONSTANTS } from "../../../constants";

export const formFieldsState: FormStateType = {
  [ADDITIONAL_INFORMATION_CONSTANTS.INSTALLATION_SOURCE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.PRODUCT_LINK]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ERC_OFFER_AMOUNT]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ITEM_RETURNED]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.AMAZON_LOCATION]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.RETURN_CENTER_POC]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ADVISED_DISPOSAL]: {
    value: "",
    errors: [],
    hidden: true,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.SELLER_CONTACT_DETAILS]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ADDRESS_LINE_1]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ADDRESS_LINE_2]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.CITY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.COUNTRY]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.PHONE]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.EMAIL]: {
    value: "",
    errors: [],
    hidden: false,
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.REPORTED_TO_PR]: {
    value: "",
    errors: [],
    hidden: false,
  },
};
